import { IBureauTenantResumo } from '../../models/bureaus.model';

export type MeurhBureausEquipesModalTipo = 'administrador' | 'membro';

export interface IMeurhBureausEquipesModalParams {
    tipo: MeurhBureausEquipesModalTipo;
    /** true: tenant por ID (administrador de Bureaus); false: seleção entre os tenants do limite. */
    tenantPorId: boolean;
    tenantsLimite: IBureauTenantResumo[];
}

export class MeurhBureausEquipesModalService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: ng.ui.bootstrap.IModalService) { }

    public open(params: IMeurhBureausEquipesModalParams): angular.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./bureaus-equipes.modal.html'),
            controller: 'MeurhBureausEquipesModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                params: () => params,
            },
        });
    }
}
